export default "__VITE_ASSET__CRfj8hKz__"